'use client'

import { authClient } from '@/frontend/auth/auth-client'
import { DropdownItem, DropdownLabel } from '@/frontend/design-system/actions/Dropdown'

const handleLogout = () => {
  void authClient.signOut({
    fetchOptions: {
      onSuccess: () => {
        window.location.href = '/baza'
      }
    }
  })
}

export function LogoutButton() {
  return (
    <DropdownItem onClick={handleLogout} className='data-focus:bg-backgroundRed'>
      <DropdownLabel className='text-contentRed'>Wyloguj się</DropdownLabel>
    </DropdownItem>
  )
}
